export default __webpack_public_path__ + "59810c4f1b579393b01a1d6546a74644.png";